<script lang="ts">
	import type { ISbStoryData } from '@storyblok/js';
	import type { SbImage } from '../types';
	import { editable } from '../editable';

	interface Props {
		content: ISbStoryData<{
			icon: SbImage;
			label: string;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<div use:editable={content} class="flex flex-col items-center gap-y-1">
	<img
		loading="lazy"
		class="h-7 w-7"
		src={content.icon.filename}
		alt={content.icon.alt}
		title={content.icon.title}
		height={28}
		width={28}
	/>
	<div class="text-[16px]/[140%] text-brown-1 lg:text-[18px]/[140%]">{content.label}</div>
</div>
